import script from "./MenuDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuDesktop.vue?vue&type=script&lang=ts&setup=true"

import "./MenuDesktop.vue?vue&type=style&index=0&id=1539bb25&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1539bb25"]])

export default __exports__